import React from "react";
import WhyChooseUs from "../pages/WhyChooseUs";
import Testimonialsabout from "../pages/TestimonialsAbout";

const AboutSection = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1, }}></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">About Rising Cab Service</h1>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="about-1-wrapper space" id="about-sec">
        <div className="container">
          <div className="row gy-40 gx-60 flex-wrap-reverse justify-content-center">
            
            <div className="col-xl-6">
              <div className="img-box1 about-2">
                {/* <div className="img1">
                  <img className="tilt-active" src="/img/about/about-1.1-1.jpg" alt="Image" />
                </div>
                <div className="img2">
                  <img className="tilt-active" src="/img/about/about-1.1-2.jpg" alt="Image" />
                </div> */}
                <div className="img3">
                  <img src="/images/about.png" alt="Image" />
                </div>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="title-area mb-25 ps-xl-4">
                <span className="sub-title style-2">Welcome to Rising Cab Service</span>

                <h2 className="sec-title">
                  Your Trusted Cab Booking & Ride Service Partner
                </h2>

                <p className="sec-text">
                  Rising Cab Service is a modern ride-hailing and taxi service platform designed to make your daily travel safe, affordable, and comfortable.
                  Whether you need a quick city ride, airport transfer, or long-distance travel, we ensure a smooth and reliable experience every time.
                </p>

                <p className="sec-text">
                  We focus on professional drivers, clean vehicles, and transparent pricing. With easy booking and 24/7 availability,
                  Rising Cab Service is committed to making transportation simple and stress-free for every customer.
                </p>

                {/* <div className="client-bottom-wrap">
                  <div className="client-wrap">
                    <div className="thumb">
                      <img src="/img/about/about-1.1-client.png" alt="img" />
                    </div>

                    <div className="text-wrap">
                      <h4 className="box-title">Rising Cab Service Team</h4>
                      <p>Founder & Operations</p>
                    </div>
                  </div>

                  <div className="sing-thumb">
                    <img src="/img/about/about-1.1-sing.png" alt="img" />
                  </div>
                </div> */}
              </div>
            </div>

          </div>

          {/* Counter Section */}
          <div className="row justify-content-xl-end">
            <div className="col-xl-8">
              <div className="counter-card-wrap style-2-inner">

                <div className="counter-card">
                  <div className="box-icon">
                    <img src="/img/icon/counter_1.1_1.svg" alt="Icon" />
                  </div>
                  <div className="media-body">
                    <h4 className="box-number">
                      <span className="counter-number">2760</span>
                      <span className="plus-simple">+</span>
                    </h4>
                    <p className="box-text">Successful Rides Completed</p>
                  </div>
                </div>

                <div className="counter-card">
                  <div className="box-icon">
                    <img src="/img/icon/counter_1.1_2.svg" alt="Icon" />
                  </div>
                  <div className="media-body">
                    <h4 className="box-number">
                      <span className="counter-number">300</span>
                      <span className="plus-simple">+</span>
                    </h4>
                    <p className="box-text">Daily Active Users</p>
                  </div>
                </div>

                <div className="counter-card">
                  <div className="box-icon">
                    <img src="/img/icon/counter_1.1_3.svg" alt="Icon" />
                  </div>
                  <div className="media-body">
                    <h4 className="box-number">
                      <span className="counter-number">2660</span>
                      <span className="plus-simple">+</span>
                    </h4>
                    <p className="box-text">Happy Customer Reviews</p>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <WhyChooseUs/>
      <Testimonialsabout/>
    </>
  );
};

export default AboutSection;